import React from "react";
import { useMediaQuery } from "react-responsive";

function AuctionFeatureLogo({ images, headers, order }) {
  const isDastop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1500px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1200px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 900px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });
  return (
    <div
      className={`valign-wrapper justify-center ${
        isMobile && "column textAlign-center "
      } ${isTablet ? "gap-2" : "gap-5"}`}
      style={{
        marginTop: isTablet
          ? "20px"
          : isSmallLaptop
          ? "30px"
          : isLaptop
          ? "60px"
          : isDastop
          ? "100px"
          : "170px",
      }}
    >
      <img
        data-aos="flip-up"
        className={`responsive-img `}
        src={images}
        alt="login-logo"
        style={{
          width: isTablet
            ? "340px"
            : isSmallLaptop
            ? "400px"
            : isDastop
            ? "600px"
            : "768px",
          order: order === 2 ? 2 : 1,
        }}
      />
      <h1
        data-aos={`${order === 2 ? "fade-right" : "fade-left"}`}
        className="cercle-purple-text"
        style={{
          fontSize: isSmallLaptop ? "25px" : isLaptop ? "35px" : "40px",
          width: isDastop ? "" : "600px",
          lineHeight: isTablet ? "30px" : "55px",
          order: order === 2 ? 1 : 2,
        }}
      >
        {headers}
      </h1>
    </div>
  );
}

export default AuctionFeatureLogo;
